import React from 'react'
import image from './../images/logo and taglines.png'

function About() {
    return (
        <section id="about">
            <div className="container">
                <div className="row flex-center">
                    <div className="col-md-6 text-center text-md-start mt-3">
                        <h4 className="fw-normal fs-2" >About HustleConnects</h4>
                        <p className="pe-xl-8" style={{fontSize: 15}}>At Hustle Connects, we believe that value lives in people not just in institutions. Our mission is to unlock that value by creating simple, structured systems where individuals can offer, access, and grow their skills in meaningful ways</p>
                        <p className="pe-xl-8" style={{fontSize: 15}}>We are building a future where work is more connected, more human, and more empowering, no matter where you start. By combining technology, trust, and local insight, we’re helping people move from hustle to livelihood, and from opportunity to ownership.</p>
                        <div className="my-2 mt-5 align-items-center">
                            <div className="col-12 col-md-12 mb-4 mb-md-3">
                                <h4 className="fw-normal fs-1">VISION STATEMENT</h4>
                                <p className="my-1" style={{ fontSize: 14 }}>
                                    To power the future of workforce by creating structured opportunities in
                                    overlooked spaces - unlocking potential, dignity, and growth for millions
                                    across the world
                                </p>
                            </div>
                            <div className="col-12 col-md-12 mb-4 mb-md-0 mt-2">
                                <h4 className="fw-normal fs-1">MISSION STATEMENT</h4>
                                <p className="my-1" style={{ fontSize: 14 }}>
                                    We build connected systems that make it simple, safe, and rewarding for
                                    people to offer and access value wherever they are
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 mb-4"><img className="w-100 mt-5 rounded-pill" src={image} alt="..." /></div>
                </div>
            </div>
        </section>
    )
}

export default About
